import classNames from 'classnames/bind';
import React from 'react';
import styles from './ChatIntro.module.scss';

const cx = classNames.bind(styles);

export default function ChatIntro(): React.ReactElement {
  return (
    <div className={styles.chatIntro}>
      <div className={cx('logo')}>
        <span />
      </div>
      <div className={cx('title')}>Welcome to CreditSights Genie</div>
      <div>
        CS Genie is the all new AI assistant for search
        <br />
        and analysis of CreditSights data
      </div>
    </div>
  );
}
